<script>
    import { getContext } from 'svelte'; const dispatch = getContext('dispatch');
    export let args = [];
</script>

<style>
    a {
        color: #13ddff;
    }
    a:hover {
        color: #13b6d1;
    }
</style>

<a href="#a" on:click|preventDefault|stopPropagation={() => {dispatch({dest: `glossary ${args.join(' ')}`})}}>{args.join(' ')}</a>